import { Application } from "../../Api";

export interface ApplicationDataInterface {
    firstName: string,
    lastName: string,
    emailAddress: string,
    phoneNumber: string,
    cvFile: File | undefined,
    additionalFiles: File[] | null,
    terms: boolean,
    // H.o.n.e.y.p.o.t
    name: string,
    email: string,
    pid:string,
    it:string
    getApplication(tenant: string, jobId: string,jobList:string): Application,
};


export class ApplicationData implements ApplicationDataInterface {
    firstName: string = "";
    lastName: string = "";
    emailAddress: string = "";
    phoneNumber: string = "";
    cvFile: File | undefined = undefined;
    additionalFiles: File[] | null = null;
    terms: boolean = false;
    // H.o.n.e.y.p.o.t
    name: string = "";
    email: string = "";
    pid:string="";
    it:string="";
    getApplication(tenant: string, jobId: string,jobList:string): Application{
        return {
            firstName: this.firstName,
            lastName: this.lastName,
            email: this.emailAddress,
            phoneNumber: this.phoneNumber,
            jobId: jobId,
            tenant: tenant,
            pid:this.pid,
            it:this.it,
            customProperties: [],
            jobList:jobList
        } as Application
    }
};